<template>
  <div class="window-box">
    <div class="main-window-s">
      <div class="title">嘉宾类型选择</div>
      <div class="content">
        <div class="radio-box">
          <label
            ><input
              class="radio_dot"
              type="radio"
              name="loginRadio"
              :value="0"
              v-model="loginType"
            />我是受邀嘉宾</label
          >
          <label
            ><input
              class="radio_dot"
              type="radio"
              name="loginRadio"
              :value="1"
              v-model="loginType"
            />我是产业嘉宾</label
          >
        </div>
      </div>
      <button class="solid-btn" @click="next">下一步</button>
    </div>
  </div>
</template>

<script>
import { sessionData } from "@/static/js/local.js";

export default {
  data() {
    return {
      loginType: 0
    };
  },
  created() {
    this.$cookies.remove("token", null, this.$cookieDomain);
    this.$cookies.remove("refreshToken", null, this.$cookieDomain);
    this.$cookies.remove("exData", null, this.$cookieDomain);
    this.$cookies.remove("validTerm", null, this.$cookieDomain);
    this.$cookies.remove("regType", null, this.$cookieDomain);

    sessionData("clean", "UserInfo");
  },
  methods: {
    next() {
      let route = this.loginType == 0 ? "/invited_login" : "/login";
      this.$router.push(route);
    }
  }
};
</script>

<style src="../../static/css/regist.css" scoped></style>